/**
 * ADR-107: "checked" and "we could not check" are different facts. When a
 * gate degrades, the confirmation must say so to the only person who can act
 * on it.
 */
export function gateInconclusiveReasonText(reason?: string): string | null {
  switch (reason) {
    case 'timed_out':
      return "The fleet's own tests did not finish within Mission Control's 60-second limit."
    case 'unavailable':
      return 'Mission Control could not get a test result from the agent host.'
    case 'deletes_unconfirmed':
      return "The agent host did not confirm it applied this change's file removals."
    default:
      return null
  }
}

export function GateInconclusiveNote({ className, reason }: { className?: string; reason?: string }) {
  const reasonText = gateInconclusiveReasonText(reason)
  return (
    <p data-testid="propose-gate-inconclusive" className={className}>
      {reasonText && <>{reasonText} </>}
      The fleet&apos;s own tests could not be run against this change, so it has not been checked in
      Mission Control. The pull request&apos;s own checks still apply before you can approve it.
    </p>
  )
}
